import { Head } from "@inertiajs/react"
import { PageHeader } from "@/components/layouts/PageHeader"
import { SourceForm } from "@/components/sources/SourceForm"

interface SourceNewProps {
  source_types: string[]
  categories: string[]
}

export default function New({ source_types, categories }: SourceNewProps) {
  return (
    <>
      <Head title="New Source" />
      <div className="space-y-6">
        <PageHeader title="New Source" description="Create a new feed source." />
        <SourceForm sourceTypes={source_types} categories={categories} />
      </div>
    </>
  )
}
